module.exports = __webpack_public_path__ + "img/android.056acc26.png";